/* eslint-disable no-plusplus */
export function roundLargestRemainder(arr, target = 10000) {
    const off = target - arr.reduce((acc, x) => acc + Math.floor(x), 0);
    const offObject = arr.reduce((acc, n, i) => ({ ...acc, [i]: n - Math.floor(n) }), {});
    const offKeys = Object.keys(offObject)
        .sort((a, b) => offObject[b] - offObject[a])
        .map((index) => +index);

    return arr.map((n, i) => Math.floor(n) + (off > offKeys.indexOf(i) && offKeys.includes(i)));
}

export function roundSmallestError(arr, target = 10000) {
    const errorFactor = (actual, rounded) => Math.abs(rounded - actual) / actual;

    const { length } = arr;
    const rounded = arr.map((n) => Math.round(n));
    const offNotAbs = target - rounded.reduce((acc, x) => acc + x, 0);
    const off = Math.abs(offNotAbs);
    const errors = [...Array(length).keys()].map((i) => [
        errorFactor(arr[i], rounded[i]),
        i,
    ]);
    const rank = [...errors].sort((a, b) => a[0] - b[0]);

    [...Array(Math.round(off)).keys()].forEach((i) => {
        if (rank[i]) rounded[rank[i][1]] += offNotAbs < 0 ? -1 : 1;
    });

    return rounded;
}

export const roundTwoDecimalDigit = (value) => Math.round(value * 100) / 100;
